import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../core/services/authentication/authentication.service';
import { OidcClientService } from '../core/services/oidc-client-ts/oidc-client.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent implements OnInit {
  isLoggedIn: boolean;
  constructor(private oidcClientService: OidcClientService, private authenticationService: AuthenticationService, private authService: AuthenticationService) {
  }
  loginAgain(): void {
    this.oidcClientService.login();
  }
  ngOnInit() {
    this.isLoggedIn = this.authenticationService.isLoggedIn();
    if (this.isLoggedIn) {
      this.authService.clearUserStorage();
      this.oidcClientService.logout();
    }
  }
}
